import { MINUTE_IN_MILLISECONDS } from "@daytrip/constants";
import { shouldRetryQuery } from "@daytrip/trpc-client-utils";
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: shouldRetryQuery({ attempts: 2 /* allows 1 retry for TRPC */ }),
            // staleTime is set to 1 minute to avoid re-fetching data on every component re-render
            staleTime: MINUTE_IN_MILLISECONDS,
            // 5 minutes is a default value for gcTime, it's just defined explicitly here
            gcTime: MINUTE_IN_MILLISECONDS * 5,
        },
    },
});
